import React from 'react';
import { CellContext } from '@tanstack/react-table';

import { DynamicIconWrapper, Icons, Tooltip } from '@components/common';

import { ILinkedSite } from '@interfaces/crowdcell/linkSite';
import { TTechnology } from '@interfaces/map/map';
import { IRentInfoItem } from '@interfaces/rent/assetRent';

import { columnSizes } from '@constants/table';

import styles from './TelecomSites.module.scss';

export interface IGetColumnsProps {
	handleOpenSiteProfile: () => void;
	handleVerifyCoordinates: () => void;
	handleUnlinkSite: () => void;
	isViewSiteAccess: boolean;
}

function getColumns({
	handleOpenSiteProfile,
	handleVerifyCoordinates,
	handleUnlinkSite,
	isViewSiteAccess,
}: IGetColumnsProps) {
	return [
		{
			header: 'Site Id',
			accessorKey: 'siteId',
			enableSorting: false,
			cell: ({ getValue }: CellContext<ILinkedSite, any>) => {
				const value = getValue();

				return <div className={styles.actionsCell}>{value}</div>;
			},
		},
		{
			header: 'Vendor',
			accessorKey: 'vendor',
			enableSorting: false,
			cell: ({ getValue }: CellContext<ILinkedSite, any>) => {
				const value = getValue();

				return <div className={styles.actionsCell}>{value.name}</div>;
			},
		},
		{
			header: 'Latitude',
			accessorKey: 'lat',
			enableSorting: false,
			size: columnSizes.size300,
			cell: ({ getValue }: CellContext<ILinkedSite, any>) => {
				const value = getValue();

				return <div className={styles.actionsCell}>{value}</div>;
			},
		},
		{
			header: 'Longitude',
			accessorKey: 'lng',
			enableSorting: false,
			size: columnSizes.size300,
			cell: ({ getValue }: CellContext<ILinkedSite, any>) => {
				const value = getValue();

				return <div className={styles.actionsCell}>{value}</div>;
			},
		},
		{
			header: 'Site type',
			accessorKey: 'siteType',
			enableSorting: false,
			cell: ({ getValue }: CellContext<ILinkedSite, any>) => {
				const value = getValue();

				return <div className={styles.actionsCell}>{value.title}</div>;
			},
		},
		{
			header: 'Technology',
			accessorKey: 'technologies',
			enableSorting: false,
			cell: ({ getValue }: CellContext<ILinkedSite, any>) => {
				const value = getValue();

				return (
					<p className={styles.actionsCell}>
						{value?.map((tech: TTechnology, i: number, arr: TTechnology[]) => {
							return <span key={tech.name}>{tech.title}{i !== arr.length - 1 && ', '}</span>;
						})}
					</p>
				);
			},
		},
		{
			header: 'Within asset radius',
			accessorKey: 'isInRadius',
			enableSorting: false,
			cell: ({ getValue }: CellContext<IRentInfoItem[], any>) => {
				const value = getValue();

				return <div className={styles.actionsCell}>{value ? 'yes' : 'no'}</div>;
			},
		},
		{
			header: 'Actions',
			accessorKey: 'actions',
			enableSorting: false,
			cell: () => {
				return (
					<div className={styles.actionsCell}>
						{isViewSiteAccess
							&& <Tooltip
								content='View'
								isDisabled={false}
							>
								<div
									className={styles.icon}
									onClick={handleOpenSiteProfile}
								>
									<DynamicIconWrapper icon={Icons.viewIcon} />
								</div>
							</Tooltip>
						}
						<Tooltip
							content='Verify Site coordinates'
							isDisabled={false}
						>
							<div
								className={styles.icon}
								onClick={handleVerifyCoordinates}
							>
								<DynamicIconWrapper
									icon={Icons.verifyCoordinates}
									isDisabled={false}
								/>
							</div>
						</Tooltip>
						<Tooltip
							content='Unlink Telecom Site you own or acquired to the Asset'
							isDisabled={false}
						>
							<div
								className={styles.icon}
								onClick={handleUnlinkSite}
							>
								<DynamicIconWrapper
									icon={Icons.unlink}
								/>
							</div>
						</Tooltip>
					</div>
				);
			},
		},
	];
}

export default getColumns;
